import styled from 'styled-components/macro';

const LockContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-right: 15px;
  opacity: 0.6;
  background-color: transparent;
  border: none;
  padding: 0;
  color: inherit;
`;

export default LockContainer;
